import React, { useState, forwardRef, useImperativeHandle } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
} from "@mui/material";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const RejectReasonDialog = forwardRef(({ onConfirm }, ref) => {
  const { t } = useTranslation(["common"]);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [inputError, setInputError] = useState({ reason: false });

  useImperativeHandle(ref, () => ({
    openDialog() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setReason("");
    setInputError({ reason: false });
    setOpen(false);
  };

  const handleSubmit = () => {
    if (reason.trim()) {
      onConfirm(reason);
      handleClose();
    } else {
      setInputError({ reason: true });
    }
  };

  return (
    <BootstrapDialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ textTransform: "capitalize" }}>
        {t("rejectWithdrawRequest")}
      </DialogTitle>
      <DialogContent dividers>
        <Label required labelText={t("enterReason")} htmlFor={"reason"} />
        <TextInput
          required
          inputError={inputError.reason}
          helperText={inputError.reason && t("validation.reasonIsRequired")}
          id={"reason"}
          placeholder={t("enterReason")}
          value={reason}
          name={"reason"}
          multiline
          rows={3}
          onChange={(e) => {
            setReason(e.target.value);
            setInputError({ reason: false });
          }}
        />
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"cancel"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"submit"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleSubmit}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default RejectReasonDialog;
